<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 38">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <circle cx="19" cy="19" r="19" fill="#383935" />
        <path
          d="M19,28.5a7.75,7.75,0,0,1-5.66-2.31A7.58,7.58,0,0,1,11,20.6a7.49,7.49,0,0,1,.62-3.05,8.42,8.42,0,0,1,1.73-2.5L19,9.5l5.65,5.55a8.21,8.21,0,0,1,1.72,2.5A7.33,7.33,0,0,1,27,20.6a7.58,7.58,0,0,1-2.34,5.59A7.75,7.75,0,0,1,19,28.5Zm0-2V12.3l-4.25,4.2a5.49,5.49,0,0,0-1.31,1.86A5.74,5.74,0,0,0,13,20.6a5.64,5.64,0,0,0,1.75,4.16A5.8,5.8,0,0,0,19,26.5Z"
          fill="#A5D867"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "InvertColors",
};
</script>

<style scoped>
svg {
  width: 38px;
  height: 38px;
}
</style>
